// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__do-n-","background":"LoginPage_background__2xnlm","overlay":"LoginPage_overlay__owtI0","content":"LoginPage_content__nEQyn"};